module.exports = __webpack_public_path__ + "media/images/core_values/respect-10d2c62b4387c8ca9c470c0694c855c1.png";